import { module } from 'modujs';
import { $html } from '../utils/dom';
import { detect } from 'detect-browser';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'link': 'quickExit',
            },
        };

        this.$link    = this.$('link')[0];
        this.$content = this.$('content')[0];

        this.links    = JSON.parse(this.getData('links'));
        this.messages = JSON.parse(this.getData('messages'));
    }

    init() {
        this.prepareLink();
        this.prepareMessage();
    }

    prepareLink() {
        if (!this.$link) {
            return;
        }

        const random = Math.round(Math.random() * (this.links.length - 1));
        this.$link.href = this.links[random];
    }

    prepareMessage() {
        if (!this.$content) {
            return;
        }

        const detectedBrowser = detect();

        const browser = [ 'chrome', 'firefox', 'edge', 'safari' ].includes(detectedBrowser.name)
            ? detectedBrowser.name
            : null;

        if (browser && this.messages[browser]) {
            this.setMessage(this.messages[browser]);
        } else if (this.messages['default']) {
            this.setMessage(this.messages['default']);
        }
    }

    setMessage(message) {
        if (typeof message === 'string' && message.length) {
            this.$content.innerHTML = message;
            return;
        }

        if (typeof message.value === 'string' && message.value.length) {
            if (message.locale && message.locale !== $html.lang) {
                this.$content.lang = message.locale;

                if (message.direction) {
                    this.$content.dir = message.direction;
                }
            }

            this.$content.innerHTML = message.value;
            return;
        }
    }

    quickExit(e) {
        e.preventDefault();
        const url = e.currentTarget.href;
        window.open(url, '_blank');
        window.location.href = 'https://www.google.com';
    }
}
